import * as actionTypes from "../actionTypes";

const initialState = {
  loading: false,
  territoriesList: null,
  licensedTerritoriesList: null,
  error: null,
  success: null
};

export const territoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_TERRITORIES_LIST_START:
      return {...state, loading: true, error: null, territoriesList: null};
    case actionTypes.GET_TERRITORIES_LIST_SUCCESS:
      return {...state, loading: false, error: null, success: null, territoriesList: action.payload};
    case actionTypes.GET_TERRITORIES_LIST_FAILURE:
      return {...state, loading: false, error: action.payload, success: null, territoriesList: null};
    // get licensed territories list
    case actionTypes.GET_LICENSED_TERRITORIES_LIST_START:
      return {...state, loading: true, error: null, licensedTerritoriesList: null};
    case actionTypes.GET_LICENSED_TERRITORIES_LIST_SUCCESS:
      return {...state, loading: false, error: null, success: null, licensedTerritoriesList: action.payload};
    case actionTypes.GET_LICENSED_TERRITORIES_LIST_FAILURE:
      return {...state, loading: false, error: action.payload, success: null, licensedTerritoriesList: null};

//delete territory
    case actionTypes.DELETE_TERRITORY_START:
      return {...state, loading: true, error: null, success: null};

// create territory
    case actionTypes.ADD_TERRITORY_START:
      return {...state, loading: true, error: null, success: null};
    case actionTypes.ADD_TERRITORY_SUCCESS:
      return {...state, loading: false, error: null, success: action.payload.success,};
    case actionTypes.ADD_TERRITORY_FAILURE:
      // console.log('reducer ', action.payload)
      return {...state, loading: false, error: action.payload.error, success: null,};
// message handler
    case actionTypes.TERRITORY_MESSAGE_HANDLER:
      return {...state, error: action.payload, success: action.payload,};
    default:
      return {...state};
  }
};
